import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { GoogleAuthToken } from '../interfaces/google-auth-token';
@Injectable({
  providedIn: 'root',
})
export class GoogleAuthApi {
  private http = inject(SiaHttpService);

  private tokenController: string = 'google-token';

  activateToken(token: GoogleAuthToken, scopeType: string) {
    const data = {
      accessCode: token.code,
      scopeId: token.scope,
      scopeType: scopeType,
    };
    let controller = scopeType.startsWith('workflow')
      ? 'token-workflow'
      : this.tokenController;

    return this.http.post(`${controller}/activate`, data);
  }

  logout(scope: string, email?: string) {
    let controller = scope.startsWith('workflow')
      ? 'token-workflow'
      : this.tokenController;
    const url = `${controller}/token/${scope}`;
    const trimmed = (email || '').trim();
    if (trimmed) {
      const params = new HttpParams().set('email', trimmed);
      return this.http.delete(url, { params });
    }
    // If email is empty/undefined, don't send the query param at all
    return this.http.delete(url, {});
  }

  getClientId(scopeName: string = 'calendar') {
    return this.http.get(`google-${scopeName}/client-id`, {
      responseType: 'text',
    });
  }
}
